import React from "react";
import { Table, Numbered } from "./Table";

const Block = ({ block, index }) => {
  switch (block.type) {
    case "h":
      return <h2 className="note-h">{block.text}</h2>;
    case "list":
      return <Numbered items={block.items} testId={`note-list-${index}`} />;
    case "contrast":
      return <Table columns={block.columns} rows={block.rows} variant="compare" testId={`note-contrast-${index}`} />;
    case "close":
      return <p className="note-close">{block.text}</p>;
    default:
      return <p className="body-copy">{block.text}</p>;
  }
};

export const NoteBody = ({ blocks }) => (
  <div className="note-blocks" data-testid="note-body">
    {blocks.map((b, i) => (
      <Block key={i} block={b} index={i} />
    ))}
  </div>
);

export default NoteBody;
